import "./Hero.css";
import hero from "../../assets/hero.jpg";
import logo from "../../assets/logodrone.webp"

export default function Hero() {
  return (
    <section className="hero">
      <img src={hero} alt="Nettoyage professionnel" />
      <div className="overlay">
        <img src={logo} alt="" className="logo" />
        <h1>Au coeur de la propreté</h1>
        <h2>Nettoyage professionnel à Marseille</h2>
        <p>Nous offrons des services de nettoyage fiables et adaptés pour entreprises <br /> et particuliers, dans toute la région marseillaise, <br />Les Bouche-du-Rhône et sa région PACA</p>
        <a href="#contact" className="cta">Demander un devis</a>
      </div>
    </section>
  );
}